export class PureCloudInfo {
    phone: string;
    contactInitiation: any;
    ouId: string;
  }